/**
 * AI服务商配置 API
 */
import request from './request';

/**
 * 获取服务商列表
 * @param {Object} params - 查询参数
 * @param {boolean} params.enabledOnly - 是否只返回启用的服务商
 * @param {number} params.page - 页码
 * @param {number} params.pageSize - 每页数量
 */
export function getProviderList(params = {}) {
  return request({
    url: '/providers',
    method: 'get',
    params
  });
}

/**
 * 获取所有启用的服务商（用于下拉选择）
 */
export function getEnabledProviders() {
  return request({
    url: '/providers/enabled',
    method: 'get'
  });
}

/**
 * 获取服务商详情
 * @param {number} id - 服务商ID
 */
export function getProviderById(id) {
  return request({
    url: `/providers/${id}`,
    method: 'get'
  });
}

/**
 * 获取服务商下的模型列表
 * @param {number} id - 服务商ID
 */
export function getProviderModels(id) {
  return request({
    url: `/providers/${id}/models`,
    method: 'get'
  });
}

/**
 * 创建服务商
 * @param {Object} data - 服务商数据
 */
export function createProvider(data) {
  return request({
    url: '/providers',
    method: 'post',
    data
  });
}

/**
 * 更新服务商
 * @param {number} id - 服务商ID
 * @param {Object} data - 更新数据
 */
export function updateProvider(id, data) {
  return request({
    url: `/providers/${id}`,
    method: 'put',
    data
  });
}

/**
 * 删除服务商
 * @param {number} id - 服务商ID
 */
export function deleteProvider(id) {
  return request({
    url: `/providers/${id}`,
    method: 'delete'
  });
}

/**
 * 切换服务商启用状态
 * @param {number} id - 服务商ID
 */
export function toggleProviderEnabled(id) {
  return request({
    url: `/providers/${id}/toggle`,
    method: 'post'
  });
}

/**
 * 测试服务商连接
 * @param {number} id - 服务商ID
 * @param {string} testPrompt - 测试提示词（可选）
 */
export function testProviderConnection(id, testPrompt = null) {
  return request({
    url: `/providers/${id}/test`,
    method: 'post',
    data: { test_prompt: testPrompt }
  });
}

/**
 * 测试新服务商配置（不保存）
 * @param {Object} data - 服务商配置
 */
export function testNewProvider(data) {
  return request({
    url: '/providers/test-new',
    method: 'post',
    data
  });
}

/**
 * 从服务商 API 获取模型列表（使用已保存的配置）
 * @param {number} id - 服务商ID
 */
export function fetchProviderModels(id) {
  return request({
    url: `/providers/${id}/fetch-models`,
    method: 'get'
  });
}

/**
 * 从服务商 API 获取模型列表（使用临时配置，用于新建时测试）
 * @param {Object} config - 临时配置
 */
export function fetchProviderModelsWithConfig(config) {
  return request({
    url: '/providers/fetch-models',
    method: 'post',
    data: config
  });
}
